var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('el-container',[_c('el-main',[_c('img',{attrs:{"src":_vm.bigpic,"alt":""}}),_c('div',{staticClass:"text"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.reson)}}),_c('el-button',{on:{"click":function($event){return _vm.goto()}}},[_vm._v("立即查看业务详情")])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }